import { ChevronDown, ChevronRight } from 'lucide-react';
import React, { useState, ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import './Accordion.css';

interface AccordionSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
  borderDetails?: React.CSSProperties;
  rightButton?: ReactNode;
  isMandatory?: boolean;
}

const Accordion: React.FC<AccordionSectionProps> = ({
  title,
  isMandatory = false,
  defaultOpen = true,
  children,
  borderDetails,
  rightButton = <></>
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Card
      style={{
        ...borderDetails,
        boxShadow: 'none',
        border: '1px solid rgba(228, 228, 228, 1)',
        borderRadius: '3px',
        background: '#FFF'
      }}
      className="customAccordion_container mb-2">
      {/* Accordion Header */}
      <Card.Header
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 600
        }}>
        <div className="d-flex w-100 justify-content-between">
          <div>
            <span style={{ marginRight: '8px' }}>
              {isOpen ? <ChevronDown /> : <ChevronRight />}
            </span>
            <span>{title}</span>
            {isMandatory && <span style={{ color: 'var(--red-color)' }}>*</span>}
          </div>
          {/* {title === 'Variables' && <PlainButton>+ Add Variables</PlainButton>} */}
          {rightButton}
        </div>
      </Card.Header>

      {/* Accordion Body */}
      {isOpen && <Card.Body id="accordion_body">{children}</Card.Body>}
    </Card>
  );
};

export default Accordion;
